import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  IconButton,
  Box
} from '@material-ui/core';
import axios from 'axios';
import envConfig from '../../../bin/env.config';
import { useSelector } from 'react-redux';
import { Bar } from 'react-chartjs-2';

import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
}));

const ProductMatchesPerGroup = ({ project }) => {
  const classes = useStyles();
  const token = useSelector((state) => state.session.token);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/product-matching-group/summary?user_type_id=${project.user_type_id}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        setData(response.data.data || []);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch product matches per group information');
        setLoading(false);
      }
    };

    fetchData();
  }, [project]);

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <Paper className={classes.root}>
        <Typography color="error">{error}</Typography>
      </Paper>
    );
  }

  // Prepare data for Chart.js
  const chartData = {
    labels: data.map(item => item.index),
    datasets: [
      {
        label: 'Number of matches',
        data: data.map(item => item.value),
        backgroundColor: '#060C3B', 
        borderRadius: 4,
        barPercentage: 0.7,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        title: {
          display: false,
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: false,
        },
        grid: {
          color: '#eee',
        },
        ticks: {
          stepSize: 2000,
        },
      },
    },
  };

  return (
    <div className={classes.root}>
      <Typography variant="h5" gutterBottom style={{ fontWeight: 700 }}>
        Number of matches (per product matching group):
      </Typography>
      <Box sx={{ height: 'calc(100vh - 200px)', minHeight: '400px', maxHeight: '600px' }}>
        <Bar data={chartData} options={options} />
      </Box>

      <Paper style={{ marginTop: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setOpen(!open)}>
          <IconButton size="small">
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
          <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
            Show data table
          </Typography>
        </div>
        <Collapse in={open}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><b>Number of matches</b></TableCell>
                  <TableCell><b>Count</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row) => (
                  <TableRow key={row.index}>
                    <TableCell>{row.index}</TableCell>
                    <TableCell>{row.value.toLocaleString()}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>
      </Paper>
    </div>
  );
};

export default ProductMatchesPerGroup; 